import { el } from "../utils/dom.ts";
import { Panel } from "./panel-base.ts";
import { getIndicatorsWeekly } from "../services/api-client.ts";
import { policyActivity, type PolicyActivityWeek } from "../utils/metrics.ts";
import { signalSourceLabel } from "./signal-source-label.ts";

// Policy Activity — weekly count of policy-domain events as a small bar chart with a
// cumulative overlay. Pure SVG (data is a handful of weeks; lightweight-charts would
// be overkill). Degrades to an empty-state when there is no policy data.
export class PolicyActivityChart extends Panel {
  constructor() {
    super({ id: "policy-activity", title: "Hoạt động chính sách", subtitle: "sự kiện / tuần" });
    this.setContent(el("div", { className: "panel-loading" }, ["Đang tải…"]));
  }

  async load(): Promise<void> {
    try {
      const { items } = await getIndicatorsWeekly("?scope=national&weeks=12");
      this.render(policyActivity(items));
    } catch {
      this.setError();
    }
  }

  private render(weeks: PolicyActivityWeek[]): void {
    if (weeks.length === 0 || weeks.every((w) => w.count === 0)) {
      this.setContent(
        el("p", { className: "muted panel-empty" }, [
          "Chưa có sự kiện chính sách trong các tuần gần đây.",
        ]),
      );
      return;
    }
    const maxCount = Math.max(...weeks.map((w) => w.count), 1);
    const bars = weeks.map((w) => {
      const h = (w.count / maxCount) * 100;
      return el("div", { className: "policy-bar-col", title: `${w.week}: ${w.count} sự kiện` }, [
        el("div", { className: "policy-bar", style: `height:${h}%` }),
        el("span", { className: "policy-bar-label" }, [w.week.replace(/^\d{4}-/, "")]),
      ]);
    });
    const total = weeks[weeks.length - 1]?.cumulative ?? 0;
    this.setContent(
      el("div", { className: "policy-chart" }, bars),
      el("div", { className: "policy-summary" }, [
        el("span", {}, [`Tổng ${total} sự kiện chính sách (${weeks.length} tuần)`]),
        signalSourceLabel("official"),
      ]),
    );
  }
}
